import * as React from "react";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpInputNumber } from "../../gvc/testNewForm/CpInputNumber";

interface Props {
  index: number;
}
export const Fluentd: React.FC<Props> = ({ index }) => {
  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.fluentd.host`}>Host</CpLabel>
          <CpInput name={`logging.${index}.fluentd.host`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`logging.${index}.fluentd.host`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.fluentd.port`}>Port</CpLabel>
          <CpInputNumber name={`logging.${index}.fluentd.port`} />
          <CpErrorWarning name={`logging.${index}.fluentd.port`} />
        </CpFormItem>
      </div>
    </>
  );
};
